module.exports = __webpack_public_path__ + "static/media/rolling.09ae61fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/cards/rolling.svg
// module id = 125
// module chunks = 0